var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/Add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.37,7.37 L7.37,2.01 C7.37,1.64016 7.67016,1.34 8.04,1.34 C8.40984,1.34 8.71,1.64016 8.71,2.01 L8.71,7.37 L14.07,7.37 C14.43984,7.37 14.74,7.67016 14.74,8.04 C14.74,8.40984 14.43984,8.71 14.07,8.71 L8.71,8.71 L8.71,14.07 C8.71,14.43984 8.40984,14.74 8.04,14.74 C7.67016,14.74 7.37,14.43984 7.37,14.07 L7.37,8.71 L2.01,8.71 C1.64016,8.71 1.34,8.40984 1.34,8.04 C1.34,7.67016 1.64016,7.37 2.01,7.37 L7.37,7.37 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.6-\\u2014-Company-\\xB7-Team-Listing-Add-Users-\\xB7-Admin",
    transform: "translate(-581.000000, -933.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(540.000000, 728.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#0067DF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAdd);
export default __webpack_public_path__ + "static/media/Blue_Add.c3ffa3041190b59345c16a24fcd10596.svg";
export { ForwardRef as ReactComponent };